export default __webpack_public_path__ + "static/media/leetcode.55886261.svg";